import { createHelpers } from 'vuex-map-fields'

const getHelpers = (namespace) => {
  const ns = namespace ? `${namespace}/` : ''

  const helpers = createHelpers({
    getterType: `${ns}getField`,
    mutationType: `${ns}updateField`
  })

  return helpers
}

export default getHelpers
